import { XMarkIcon } from "@heroicons/react/24/outline"
import React from "react"
import { twMerge } from "tailwind-merge"

interface SocialProofNotificationCardProps {
  imageUrl: string
  visible: boolean
  isMobile: boolean
  closeNotification: (e: React.MouseEvent<HTMLButtonElement>) => void
  children: React.ReactNode
}

const getMobileCardAnimationClasses = (visible: boolean) => {
  return visible ? "translate-y-0 opacity-100" : "translate-y-[140%] opacity-0"
}

const getDesktopCardAnimationClasses = (visible: boolean) => {
  return visible ? "translate-x-0 opacity-100" : "translate-x-[-120%] opacity-0"
}

const SocialProofNotificationCard = ({
  imageUrl,
  visible,
  isMobile,
  closeNotification,
  children
}: Readonly<SocialProofNotificationCardProps>) => {
  return (
    <div
      className={twMerge(
        "fixed z-[999998] rounded-full border border-[#e3e8ee] bg-white/95 p-4 shadow-[0_20px_40px_rgba(0,0,0,0.12)] backdrop-blur-sm transition-all duration-500",
        visible ? "pointer-events-auto" : "pointer-events-none",
        isMobile ? "inset-x-4 bottom-4" : "bottom-3 left-3 w-[380px]",
        isMobile ? getMobileCardAnimationClasses(visible) : getDesktopCardAnimationClasses(visible)
      )}>
      <button
        type="button"
        aria-label="Close notification"
        onClick={closeNotification}
        className="absolute right-3 top-3 inline-flex h-5 w-5 items-center justify-center rounded-full text-[#9aa3af] hover:bg-[#f0f2f5]">
        <XMarkIcon className="h-3.5 w-3.5" />
      </button>
      <div className="flex items-center gap-3">
        <div className="inline-flex h-14 w-14 shrink-0 flex-col">
          <img src={imageUrl} alt="" className="rounded-full" />
        </div>
        <div className="min-w-0">{children}</div>
      </div>
    </div>
  )
}

export default SocialProofNotificationCard
